import { client } from '@/app/api';

export const sessionLogin = () => client.get('/internal/auth/session-login');
